import { GetFullUserType } from '@orbit/api-types'
import api from '@lib/api'
import { useQuery } from '@tanstack/react-query'

export const useMe = () => {
	return useQuery<GetFullUserType>({
		queryKey: ['me'],
		queryFn: async () => {
			const response = await api.get<GetFullUserType>('/users')
			return response.data
		},
		retry: 1,
	})
}

